export default {"width":256,"height":45};